// extracted by mini-css-extract-plugin
module.exports = {"currencySelector":"_1-l4tWzh","currencyContainer":"_3dtAyms8"};